<template>
  <v-container class="pa-0">
    <AccountToolBar
      class="pa-3"
      :account-info="account"
    />
    <div class="main-page fill-height">
      <!-- <v-toolbar flat>
        <template v-slot:extension> -->
      <v-tabs
        v-model="tabs"
        color="primary"
        class="orderTabs"
        fixed-tabs
      >
        <!-- border-bottom: 2.5px solid #aae1dc; -->
        <!-- <v-divider></v-divider> -->
        <!-- <v-tabs-slider></v-tabs-slider> -->
        <v-tab
          v-for="item in tabList[isUserParams]"
          :key="item.value"
          class="review-tab"
        >
          <div
            color="primary"
            class="font-weight-bold"
            style="font-size: 18px"
          >
            {{ item.text }}
          </div>
        </v-tab>
      </v-tabs>
      <!-- </template>
      </v-toolbar> -->

      <v-tabs-items v-model="tabs">
        <v-tab-item
          v-for="item in tabList[isUserParams]"
          :key="item.value"
        >
          <v-container
            v-if="item.value === 0"
            class="pa-0"
          >
            <ReviewEmpty
              v-if="reviewShow"
              @bookingDate="bookingDate"
            />
            <OrderRoom
              v-else
              :order-date="orderDate"
            />
          </v-container>
          <v-container v-if="item.value === 1" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import AccountToolBar from '/src/components/AccountToolBar.vue'
import ReviewEmpty from './BookingContent/ReviewEmpty.vue'
import OrderRoom from './BookingContent/OrderRoom.vue'

export default {
  components: {
    AccountToolBar,
    ReviewEmpty,
    OrderRoom
  },
  data () {
    return {
      tabList: {
        0: [
          {
            text: '代客訂房',
            value: 0
          },
          {
            text: '訂單查詢',
            value: 1
          },
          {
            text: '現場報到',
            value: 2
          }
        ],
        1: [
          {
            text: '快速訂房',
            value: 0
          },
          {
            text: '營區介紹',
            value: 1
          },
          {
            text: '營區公約',
            value: 2
          }
        ]
      },
      tabs: 0,
      account: {
        img: 'https://picsum.photos/500/300?image=16',
        accountId: '1',
        accountName: '不想回家',
        address: '台東縣',
        mobile: '0965-507-555'
      },
      orderDate: null,
      reviewShow: true
    }
  },
  computed: {
    isUserParams () {
      return this.$route.params.isUser !== 0 ? 1 : 0
    }
  },
  mounted () {

    //  console.log('date/id',this.$route.params.date,this.$route.params.id);
  },
  methods: {
    bookingDate (val) {
      this.reviewShow = false
      this.orderDate = val
    }
  }
}
</script>

<style scoped>
.review-tab {
  /* position: relative; */
  background-color: #f0f0f0;
}
</style>
<style>
.orderTabs .v-slide-group__prev{
display: none !important;
}

</style>
